import Alpine from 'alpinejs';
import Swiper from 'swiper';
import 'swiper/css';

import { EffectCreative, Pagination } from 'swiper/modules';

// Alpine data for projects filtering
const projectsData = {
    activeTag: null,
    async triggerRefreshAnimation() {
        const swiperEl = this.$refs.swiperEl || this.$el.querySelector('[x-ref="swiperEl"]') || this.$el.querySelector('[data-swiper="projects"]');
        if (!swiperEl) return;
        swiperEl.classList.remove('swiper-show');
        await this.$nextTick();
        setTimeout(() => {
            if (swiperEl.swiper) swiperEl.swiper.update();
            swiperEl.classList.add('swiper-show');
        }, 100);
    },
    toggleFilter(tag) {
        console.log('toggleFilter', tag, 'current:', this.activeTag);
        if (this.activeTag === tag) {
            this.activeTag = null;
        } else {
            this.activeTag = tag;
        }
        this.triggerRefreshAnimation();
    },
    isProjectVisible(el) {
        if (this.activeTag === null) return true;
        const tagsData = el.dataset.projectTags;
        if (!tagsData) return true;
        try {
            const tags = JSON.parse(tagsData);
            return tags[this.activeTag] !== undefined;
        } catch (e) {
            console.warn('Failed to parse project tags', e);
            return true;
        }
    },
    init() {
        console.log('Alpine projects init', this.$el);
    }
};

// Initialize Swiper on an element
function initSwiper(element) {
    const useCreativeEffect = element.dataset.swiperEffect !== 'slide';

    const options = {
        modules: [EffectCreative, Pagination],
        slidesPerView: 'auto',
        centeredSlides: !useCreativeEffect ? false : true,
        grabCursor: true,
        pagination: {
            el: element.closest('section')?.querySelector('.swiper-pagination'),
            clickable: true,
        },
    };

    if (useCreativeEffect) {
        options.effect = 'creative';
        options.creativeEffect = {
            limitProgress: 10,
            prev: {
                translate: ["calc(-100% - var(--space-between, 0px))", 0, 0],
                rotate: [0, 0, 2],
            },
            next: {
                translate: ["calc(100% + var(--space-between, 0px))", 0, 0],
                rotate: [0, 0, 2],
            },
        };
    }

    return new Swiper(element, options);
}

// Self-initialize when script loads
(function init() {
    // Register Alpine data
    Alpine.data('projects', () => projectsData);

    // Start Alpine if not already started
    if (!window.Alpine) {
        window.Alpine = Alpine;
        Alpine.start();
    }

    // Initialize all project swipers
    const swiperElements = document.querySelectorAll('[data-swiper="projects"]');
    swiperElements.forEach(el => {
        initSwiper(el);
        el.classList.add('swiper-show');
    });

    console.log('projects-swiper.js initialized', swiperElements.length, 'swipers');
})();